import React, { useEffect } from 'react'
import { Answer } from 'enums'
import useRoute from 'hooks/useRoute'
import { equalArray } from 'utils'

import Question from 'components/Question'

const Q5 = () => {
  const { answerHistory, routes, setRoutes } = useRoute()

  useEffect(() => {
    if (
      equalArray(answerHistory, [
        [0, Answer.YES], // チュールなどの柔らかい素材感が好き
        [1, Answer.NO], // 王道なデザインが好きではない
        [3, Answer.NO], // ボリュームのあるドレスが好きではない
      ]) ||
      equalArray(answerHistory, [
        [0, Answer.YES], // チュールなどの柔らかい素材感が好き
        [1, Answer.YES], // 王道なデザインが好き
        [2, Answer.NO], // 良いものであれば価格を気にせずに選ぶ方ではない
        [3, Answer.NO], // ボリュームのあるドレスが好きではない
      ])
    ) {
      setRoutes({
        yes: {
          index: 5, // 大人っぽい雰囲気のドレスが好き？
        },
        no: {
          index: 0, // キュートタイプ
          done: true,
        },
      })
    } else if (
      equalArray(answerHistory, [
        [0, Answer.NO], // チュールなどの柔らかい素材感が好きではない
        [3, Answer.YES], // ボリュームのあるドレスが好き
        [2, Answer.YES], // 良いものであれば価格を気にせずに選ぶ方だ
      ])
    ) {
      setRoutes({
        yes: {
          index: 6, // 豪華で華やかなドレスが好き？
        },
        no: {
          index: 7, // ドレスは他の人と被りたくない？
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Question q={<>ドレスは海外の人気ブランドがいい？</>} routes={routes} />
  )
}

export default Q5
